import {
    ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, QueryList, Renderer2, ViewChild, ViewChildren,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService, ChatService, MatchMessage, QuestionMessage, SocketService, User, LoggerService, SpeedflirtUser } from 'angular-lib';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../services/loader.service';
import { HttpParams } from '@angular/common/http';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { TimeAgoPipe } from 'angular2-moment/time-ago.pipe';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'ez-speedflirt',
    template: require('./speedflirt.component.html'),
    styles: [require('./speedflirt.component.less')],
    encapsulation: ViewEncapsulation.None,
    animations : [
        trigger('showMap', [
            state('true', style({
                transform: 'translate3d(130%,0,0)'
            })),
            state('false',   style({
                transform: 'translate3d(5%,0,0)'
            })),
            transition('true <=> false', animate(200))
        ]),
        trigger('matchContinueUp', [
            state('true', style({
                transform: 'translate3d(0,0,0)'
            })),
            state('false', style({
                transform: 'translate3d(0,300%,0)'
            })),
            transition('false => true', animate('400ms 300ms'))
        ]),
        trigger('matchModalDown', [
            state('true', style({
                transform: 'translate3d(0,0,0)'
            })),
            state('false', style({
                transform: 'translate3d(0,-150%,0)'
            })),
            transition('false => true', animate('500ms 300ms',
                keyframes([
                    style({transform: 'translate3d(0,-150%,0)', offset: 0}),
                    style({transform: 'translate3d(0,15px,0)', offset: 0.8}),
                    style({transform: 'translate3d(0,0,0)', offset: 1.0})
                ]))
            )
        ])
    ]
})

export class SpeedflirtComponent implements OnInit, OnDestroy {
    @ViewChild('cardWrapper') private cardWrapper: ElementRef;
    @ViewChildren(SwiperDirective) private swiper: QueryList<SwiperDirective>;
    public mode: string = 'profile';
    public speedflirtApiUrl = '/ws/list/speedflirt';
    public userList: Array<SpeedflirtUser> = [];
    public env = null;
    public albumFullMode: boolean = false;
    public picIndex: number = 0;
    public tmpHide: boolean = false;
    public me: User = null;
    public matchedUser: SpeedflirtUser = null;
    public matchStr: string = '';
    public lockedAction: boolean = false;
    public userListViewed: Array<number> = [];
    public matchUserPictureUrl: string = '';
    public matchMyUserPictureUrl: string = '';
    public noDescriptionMessage: string = '';

    private askPrivateSentence: string = '';
    private panAnimationStarted: boolean = false;
    private alreadyAskPrivateAuth: boolean = false;
    private hidePagination: boolean = false;
    private numberPhotoShown: number = 0;
    private showMatchModal: boolean = false;

    private albumUrl: string;

    private config: SwiperConfigInterface = {
        direction: 'vertical',
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        allowSlidePrev: true,
        allowSlideNext: true
    };

    // Picture full mode events
    private lastScale: number = 1;
    private posX: number = 0;
    private posY: number = 0;
    private lastPosX: number = 0;
    private lastPosY: number = 0;
    private maxPosX: number = 0;
    private maxPosY: number = 0;
    private scale: number = 0;

    constructor(
        private apiService: ApiService,
        private translateService: TranslateService,
        public route: ActivatedRoute,
        private loaderService: LoaderService,
        private socketService: SocketService,
        private router: Router,
        private changeDetector: ChangeDetectorRef,
        private zone: NgZone,
        private menuService: MenuService,
        private renderer: Renderer2,
        private chatService: ChatService
    ) {
        this.env = environment;
    }

    public ngOnInit() {
        this.albumUrl = '/member/profile/album/upload';
        this.loaderService.show();
        this.renderer.addClass(document.querySelector('#logged-content'), 'no-overflow');
        this.route.data.subscribe((data) => {
            this.mode = data.mode;
            this.apiService.user().subscribe(user => {
                    setTimeout(() => {
                        this.me = user;
                    });
                },
                err => console.error('failed to get me ' + err.message),
            );

            if (this.mode === 'speedflirt') {
                this.loadSpeeflirt();
            } else {
                this.route.params.subscribe((params) => {
                    this.apiService.user(params.id).subscribe(
                        user => {
                            let speedflirtUser = SpeedflirtUser.fromUser(user);
                            // show map by default
                            speedflirtUser.showMap = true;
                            this.userList.push(speedflirtUser);
                            this.alreadyAskPrivateAuth =
                                typeof user.hasUserRequests[QuestionMessage.PICTURE_AUTH_USER_REQUEST_ID] !== 'undefined'
                                && user.hasUserRequests[QuestionMessage.PICTURE_AUTH_USER_REQUEST_ID] === true;
                            this.translateService.get('speedflirt.ask-to-see-private').subscribe(res => {
                                this.askPrivateSentence = res.replace('{pseudo}', user.displayname);
                            });

                            this.translateService.get('speedflirt.no-description').subscribe((str) => {
                                this.noDescriptionMessage = str.replace('{login}', user.displayname);
                            });

                            // set shown picture number
                            this.numberPhotoShown = this.countFirstUserShownPicture();
                            // hide pagination if shown user has only one picture
                            this.hidePagination =  this.numberPhotoShown <= 1;
                            if (this.hidePagination) {
                                this.config.allowSlideNext = false;
                                this.config.allowSlidePrev = false;
                            }
                            this.loaderService.hide();
                        },
                        error => {
                            this.loaderService.hide();
                        }
                    );
                });
            }
        });
    }

    public ngOnDestroy(): void {
        this.renderer.removeClass(document.querySelector('#logged-content'), 'no-overflow');
    }

    private loadSpeeflirt(amend?: boolean) {
        let params: HttpParams = new HttpParams();
        this.userListViewed.map((item) => {
            params = params.append('excludes[]', item.toString());
        });

        let options: any = {};
        options.params = params;
        this.apiService.get(this.speedflirtApiUrl, options)
            .map(data => data.listData.map(ot => new SpeedflirtUser(ot)))
            .subscribe(
                list => {
                    if (!amend) {
                        list.map((user) => {
                            this.prepareUser(user);
                        });
                        this.userList = list;
                        if (this.userList.length > 0) {
                            this.userListViewed.push(this.userList[0].id);
                        }
                    } else {
                        list.map((newUser) => {
                            let found = false;
                            this.userList.map((oldUser) => {
                                if (oldUser.id === newUser.id) {
                                    found = true;
                                }
                            });

                            if (found === false) {
                                this.prepareUser(newUser);
                                this.userListViewed = [];
                                this.userList.push(newUser);
                            }
                        });
                    }
                    // set shown picture number
                    this.numberPhotoShown = this.countFirstUserShownPicture();
                    this.hidePagination =  this.numberPhotoShown <= 1;
                    if (this.hidePagination) {
                        this.config.allowSlideNext = false;
                        this.config.allowSlidePrev = false;
                    }

                    if (this.userList.length > 0) {
                        this.translateService.get('speedflirt.no-description').subscribe((str) => {
                            this.noDescriptionMessage = str.replace('{login}', this.userList[0].displayname);
                        });
                    }

                    this.loaderService.hide();
                },
                error => {
                    LoggerService.error(error);
                    this.loaderService.hide();
                }
            );
    }

    public doAction(user: SpeedflirtUser, action) {
        if (user) {
            let body = JSON.stringify({
                userIdTo: user.id.toString(),
            });

            if (action === 'accept') {
                this.apiService.post(this.speedflirtApiUrl, body)
                    .subscribe(result => {
                        if (result.result.matched === true) {
                            this.showMatch(user);
                            this.chatService.showChatUnreadMessagesNotification();
                        }
                    });
            } else {
                this.apiService.delete(this.speedflirtApiUrl, {body: body})
                    .subscribe(_ => {});
            }
        }
    }

    public click(type) {
        if (this.lockedAction === true) {
            return false;
        }
        this.lockedAction = true;
        let cardElement = this.swiper.first.swiper().el.closest('.box');
        let transform = 'translate3d(200%,0,0) rotate(40deg)';
        let marker: any = document.querySelector('.accept-marker');
        if (type === 'refuse') {
            marker = document.querySelector('.refuse-marker');
            transform = 'translate3d(-200%,0,0) rotate(-40deg)';
        }

        this.manageMarker([
            {
                element: marker,
                opacity: 1
            }
        ]);

        cardElement.animate([
            {transform: 'translate3d(0,0,0) rotate(0)'},
            {transform: transform}
        ], {
            duration: 300
        });

        marker.animate(
            [
                {
                    transform: 'translate3d(-50%, -50%, 0) scale(1)',
                    opacity: 1
                },
                {
                    transform: 'translate3d(-50%, -50%, 0) scale(4)',
                    opacity: 0
                }
            ],
            {
                duration: 200
            }
        );

        this.doAction(this.userList[0], type);

        // setTimeout used instead of Animation.onfinish because safari don't handle it correctly (or too slow)
        setTimeout(() => {
            this.animationFinished();
        }, 250);
        // reset des markers
        setTimeout(() => {
            this.manageMarker([
                {
                    element: marker,
                    opacity: 0
                }
            ]);
        }, 150);
    }

    public pan(event) {
        if (
            this.albumFullMode === true
            || this.mode !== 'speedflirt'
            || (Math.abs(event.deltaY) > Math.abs(event.deltaX) && !this.panAnimationStarted)
        ) {
            return false;
        }

        let element = event.target.closest('.box');
        let positionRatioX = event.deltaX / element.offsetWidth;

        const horizontalOffset = Math.min(Math.max(event.deltaX / element.offsetWidth, -1), 1);
        let rotate = horizontalOffset * 20;
        let initT = 'translateX(' + (positionRatioX * 100) + '%) rotate(' + rotate + 'deg)';
        let markerOpacity = Math.abs(horizontalOffset) * 2;
        if (markerOpacity > 1) {
            markerOpacity = 1;
        }

        // get markers
        let acceptMarker = document.querySelector('.accept-marker');
        let refuseMarker = document.querySelector('.refuse-marker');

        // we don't start the animation right now if the user doesn't have swipe enough, to prevent conflicts with photos swiper,
        // or if he already start the animation
        if (positionRatioX > 0.15 || positionRatioX < -0.15 || this.panAnimationStarted) {
            if (this.panAnimationStarted === false) {
                this.panAnimationStarted = true;
            }
            element.style.transform = initT;
            if (positionRatioX > 0) {
                this.manageMarker([
                    {
                        element: acceptMarker,
                        opacity: markerOpacity
                    },
                    {
                        element: refuseMarker,
                        opacity: 0
                    }
                ]);
            } else {
                this.manageMarker([
                    {
                        element: acceptMarker,
                        opacity: 0
                    },
                    {
                        element: refuseMarker,
                        opacity: markerOpacity
                    }
                ]);
            }
        } else {
            element.style.transform = 'initial';
            this.manageMarker([
                {
                    element: acceptMarker,
                    opacity: 0
                },
                {
                    element: refuseMarker,
                    opacity: 0
                }
            ]);
        }

        if (event.isFinal === true) {
            // no more animation
            this.panAnimationStarted = false;
            // Not enough, back to initial position
            if ( (positionRatioX < 0.5 && positionRatioX >= 0) || (positionRatioX < 0 && positionRatioX >= -0.5) ) {
                element.style.transform = 'initial';
                this.manageMarker([
                    {
                        element: acceptMarker,
                        opacity: 0
                    },
                    {
                        element: refuseMarker,
                        opacity: 0
                    }
                ]);
            } else {
                if (this.lockedAction === true) {
                    return false;
                }
                this.lockedAction = true;

                let tranform = 'translate3d(300%,0,0) rotate(20deg)';
                let action = 'accept';

                let markerToAnimate: any = acceptMarker;
                if (positionRatioX <= -0.5) {
                    tranform = 'translate3d(-300%,0,0) rotate(-20deg)';
                    action = 'refuse';
                    markerToAnimate = refuseMarker;
                }

                element.animate([
                    {transform: initT},
                    {transform: tranform}
                ], {
                    duration: 200
                });

                markerToAnimate.animate(
                    [
                        {
                            transform: 'translate3d(-50%, -50%, 0) scale(1)',
                            opacity: 1
                        },
                        {
                            transform: 'translate3d(-50%, -50%, 0) scale(4)',
                            opacity: 0
                        }
                    ],
                    {
                        duration: 200
                    }
                );

                // setTimeout used instead of Animation.onfinish because safari don't handle it correctly (or too slow)
                setTimeout(() => {
                    this.animationFinished();
                }, 150);
                // reset des markers
                setTimeout(() => {
                    this.manageMarker([
                        {
                            element: acceptMarker,
                            opacity: 0
                        },
                        {
                            element: refuseMarker,
                            opacity: 0
                        }
                    ]);
                }, 150);

                this.doAction(this.userList[0], action);
            }
        }
    }

    private animationFinished () {
        this.userList.splice(0, 1);
        if (this.userList.length > 0) {
            this.userListViewed.push(this.userList[0].id);
        }
        // force angular to detect now, to prevent animation "freeze" on ios
        this.changeDetector.detectChanges();
        // updating shown picture number
        this.numberPhotoShown = this.countFirstUserShownPicture();
        // hide pagination if shown user has only one picture
        this.hidePagination = this.userList.length > 0 && this.numberPhotoShown <= 1;
        if (typeof this.swiper.first !== 'undefined') {
            let swiper = this.swiper.first.swiper();
            if (this.hidePagination) {
                swiper.allowSlideNext = false;
                swiper.allowSlidePrev = false;
            } else {
                swiper.allowSlidePrev = this.picIndex > 0;
                swiper.allowSlideNext = this.picIndex < (this.numberPhotoShown - 1);
            }
        }

        if (this.userList.length < 5) {
            this.loadSpeeflirt(true);
        }
        setTimeout(() => {
            this.lockedAction = false;
        }, 50);
    }

    public changeMode () {
        this.albumFullMode = !this.albumFullMode;
        if (this.albumFullMode) {
            this.menuService.backButtonOn(() => {
                this.changeMode();
                return true;
            });
        } else {
            this.menuService.cancelBackButton();
        }
        this.tmpHide = true;
        // updating shown picture number
        this.numberPhotoShown = this.countFirstUserShownPicture();
        let swiper = this.swiper.first.swiper();
        // hide pagination if shown user has only one shown picture
        this.hidePagination = this.numberPhotoShown <= 1;
        if (this.hidePagination) {
            swiper.allowSlideNext = false;
            swiper.allowSlidePrev = false;
        } else {
            swiper.allowSlidePrev = this.picIndex > 0;
            swiper.allowSlideNext = this.picIndex < (this.numberPhotoShown - 1);
        }
        // security on picture index preventing index out of bounds
        if (this.picIndex > this.numberPhotoShown - 1) {
            this.picIndex = this.numberPhotoShown - 1;
        }
        // update works better when called directly on first... dunno why
        this.swiper.first.update();
    }

    public translateFallback () {
        if (this.tmpHide) {
            this.tmpHide = false;
            // need to be triggered manually (third party async code that doesn't trigger angular change detection)
            this.changeDetector.detectChanges();
        }
    }

    public showMatch (user: SpeedflirtUser) {
        this.matchedUser = user;
        setTimeout(() => {
            this.showMatchModal = true;
        }, 400);
        this.translateService.get('speedflirt.mutual').subscribe((str) => {
            this.matchStr = str.replace('{displayname}', '');
        });

        this.matchUserPictureUrl = this.getMainPictureUrl(user);
        this.matchMyUserPictureUrl = this.getMainPictureUrl(this.me);

        // Send match alert
        let matchMessage = new MatchMessage(user.id, user.channelId);
        this.socketService.emit(matchMessage);
    }

    public askPictureAuth($event, userParam: User) {
        // prevent changing display mode
        $event.stopPropagation();
        this.loaderService.show();
        this.chatService.sendQuestion(QuestionMessage.PICTURE_AUTH_USER_REQUEST_ID, userParam.id);
        this.apiService.user(userParam.id)
            .subscribe(
                userWs => {
                    this.userList.forEach((user: User, index: number) => {
                        if (user.id === userWs.id) {
                            this.userList[index].hasUserRequests = userWs.hasUserRequests;
                            this.alreadyAskPrivateAuth =
                                typeof this.userList[index].hasUserRequests[QuestionMessage.PICTURE_AUTH_USER_REQUEST_ID] !== 'undefined'
                                && this.userList[index].hasUserRequests[QuestionMessage.PICTURE_AUTH_USER_REQUEST_ID] === true;
                        }
                    });
                    this.loaderService.hide();
                },
                error => {
                    this.loaderService.hide();
                }
            );
    }

    public chat(user: User) {
        this.showMatchModal = false;
        this.router.navigate(['/member/chat', user.id]);
    }

    private countFirstUserShownPicture(): number {
        // count shown pictures
        let shownPictureCount = 0;
        if (this.userList.length > 0) {
            // if we are on full mode, private picture are not shown, except if authorization is granted on profile mode
            if (!this.albumFullMode) {
                this.userList[0].pictures.forEach(photo => {
                    if (
                        ['all', 'default'].indexOf(photo.access) > -1
                        || this.mode === 'profile'
                    ) {
                        shownPictureCount++;
                    }
                });
                // hide pagination if shown user has only one shown picture
                this.hidePagination = shownPictureCount <= 1;
            } else {
                shownPictureCount = this.userList[0].pictures.length;
            }
        }
        return shownPictureCount;
    }

    public generateMapUrl(user: SpeedflirtUser) {
        let googleApiKey = 'AIzaSyAatoLm4JQWByw8CnpbF0VgycjPuB-zkOM';
        let latitude = '';
        let longitude = '';

        if (user.crossGeoloc !== undefined) {
            latitude = user.crossGeoloc.city.latitude.toString();
            longitude = user.crossGeoloc.city.longitude.toString();
        } else {
            latitude = user.coordinates.latitude.toString();
            longitude = user.coordinates.longitude.toString();
        }

        let url = 'https://maps.googleapis.com/maps/api/staticmap?' +
            'center=' + latitude + ',' + longitude + '&zoom=13&size=640x640&maptype=roadmap' +
            '&markers=icon:https://www.teaser.dating/img/location.png%7C' + latitude + ',' + longitude +
            '&key=' + googleApiKey +
            '&style=element:geometry%7Ccolor:0xf5f5f5' +
            '&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161' +
            '&style=element:labels.text.stroke%7Ccolor:0xf5f5f5' +
            '&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd' +
            '&style=feature:landscape.natural%7Celement:geometry.fill%7Ccolor:0xfff8f1' +
            '&style=feature:landscape.natural.landcover%7Celement:geometry.fill%7Ccolor:0xabc7d7' +
            '&style=feature:landscape.natural.terrain%7Celement:geometry.fill%7Ccolor:0xabc7d7' +
            '&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee' +
            '&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575' +
            '&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5' +
            '&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e' +
            '&style=feature:road%7Celement:geometry%7Ccolor:0xffffff' +
            '&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575' +
            '&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada' +
            '&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161' +
            '&style=feature:road.local%7Cvisibility:off&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e' +
            '&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5' +
            '&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee' +
            '&style=feature:water%7Ccolor:0x42dbff' +
            '&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9' +
            '&style=feature:water%7Celement:geometry.fill%7Ccolor:0xabc7d7' +
            '&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e';

        return url;
    }

    public getMainPictureUrl(user: User): string {
        let url = '';

        let matchUserPicture = user.getDefaultPicture();
        if (matchUserPicture === null) {
            let myPics = user.getPublicPictures();
            if (myPics.length > 0) {
                matchUserPicture = myPics[0];
            }
        }

        if (matchUserPicture !== null) {
            url = user.getPictureUrl(
                matchUserPicture,
                user.channelId,
                environment.scheme,
                environment.statichost,
                false,
                200,
            );
        } else {
            url = '/img/' + (user.genderId === 1 ? 'woman' : 'man') + '.jpg';
        }

        return url;
    }

    private swiperTransitionEnd() {
        let swiper = this.swiper.first.swiper();
        if (this.hidePagination) {
            swiper.allowSlideNext = false;
            swiper.allowSlidePrev = false;
        } else {
            swiper.allowSlidePrev = this.picIndex > 0;
            swiper.allowSlideNext = this.picIndex < (this.numberPhotoShown - 1);
        }
        swiper.update();
    }

    private prepareUser(user: SpeedflirtUser): void {
        if (user.crossGeoloc) {
            let obs = this.translateService.get('speedflirt.cross-geoloc.man');
            if (user.genderId === 1) {
                obs = this.translateService.get('speedflirt.cross-geoloc.woman');
            }
            obs.subscribe(
                data => {
                    user.crossedTimeAgo = data.replace(
                        '{time}',
                        new TimeAgoPipe(this.changeDetector, this.zone)
                            .transform(user.crossGeoloc.created_at, true)
                    );
                });
        }
        user.showMap = true;
    }

    private manageMarker(markers: Array<{element: any, opacity: number}>) {
        markers.forEach((marker) => {
            if (marker.opacity > 0) {
                marker.element.style.opacity = marker.opacity;
                marker.element.style.display = 'block';
                marker.element.style.transform = 'translate3d(-50%, -50%, 0) scale(' + marker.opacity + ')';
            } else {
                marker.element.style.opacity = '0';
                marker.element.style.display = 'none';
                marker.element.style.transform = 'translate3d(-50%, -50%, 0)';
            }
        });
    }

    public pinchPicture(event: any) {
        this.picturePosition(event);
    }

    public panPicture(event: any) {
        this.picturePosition(event);
    }

    public pinchEnd(event: any) {
        this.lastScale = this.scale;
    }

    public panPictureEnd(event: any) {
        this.lastPosX = this.posX < this.maxPosX ? this.posX : this.maxPosX;
        this.lastPosY = this.posY < this.maxPosY ? this.posY : this.maxPosY;
    }

    public picturePosition(event: any) {
        if (event.isFinal === true) {
            return false;
        }

        if (event.type === 'pinch') {
            if (event.additionalEvent === 'pinchout') {
                this.scale = event.scale - 1;
            }

            if (event.additionalEvent === 'pinchin') {
                this.scale = 1 - event.scale;
            }

            this.scale = this.lastScale * event.scale;
        }

        if (event.type === 'pan') {
            this.scale = this.lastScale;
        }

        if (this.scale < 1) {
            this.scale = 1;
        }

        if (this.scale > 2) {
            this.scale = 2;
        }

        let swiper = this.swiper.first.swiper();
        let picture = swiper.slides[swiper.activeIndex];
        let width = picture.querySelector('img').width;
        let height = picture.querySelector('img').height;

        this.posX = this.lastPosX + event.deltaX;
        this.posY = this.lastPosY + event.deltaY;
        this.maxPosX = Math.ceil((this.scale - 1) * width / 2);
        this.maxPosY = Math.ceil((this.scale - 1) * height / 2);
        if (this.posX > this.maxPosX) {
            this.posX = this.maxPosX;
        }

        if (this.posX < -this.maxPosX) {
            this.posX = -this.maxPosX;
        }

        if (this.posY > this.maxPosY) {
            this.posY = this.maxPosY;
        }
        if (this.posY < -this.maxPosY) {
            this.posY = -this.maxPosY;
        }

        let transform =
            'translate3d(' + this.posX + 'px,' + this.posY + 'px, 0) ' +
            'scale3d(' + this.scale + ', ' + this.scale + ', 1)';

        picture.style.transform = transform;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/speedflirt/speedflirt.component.ts